import { isValidFokusClipboard } from '../clipboardUtils';

/** Override, then the system clipboard, then the in-memory copy from this session. */
export async function readClipboardPayload(override, fallback) {
  if (override) return override;
  try {
    const text = await navigator.clipboard.readText();
    return JSON.parse(text);
  } catch {
    return fallback ?? null;
  }
}

export async function clipboardHasFokusData(fallback) {
  try {
    const text = await navigator.clipboard.readText();
    const data = JSON.parse(text);
    return isValidFokusClipboard(data);
  } catch {
    return !!fallback;
  }
}
